(function () {
  function initCopyLinkButtons(root) {
    root.querySelectorAll('[data-gt-article-copy-link]').forEach(function (button) {
      if (button.dataset.gtCopyInit === 'true') return;
      button.dataset.gtCopyInit = 'true';

      var defaultLabel = button.getAttribute('aria-label') || 'Copy link';
      var url = button.dataset.url || window.location.href;

      button.addEventListener('click', function () {
        function onCopied() {
          button.classList.add('is-copied');
          button.setAttribute('aria-label', 'Link copied');
          window.setTimeout(function () {
            button.classList.remove('is-copied');
            button.setAttribute('aria-label', defaultLabel);
          }, 2000);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(onCopied).catch(fallbackCopy);
          return;
        }

        fallbackCopy();

        function fallbackCopy() {
          var input = document.createElement('input');
          input.value = url;
          document.body.appendChild(input);
          input.select();
          try {
            document.execCommand('copy');
            onCopied();
          } catch (e) {
            /* ignore */
          }
          document.body.removeChild(input);
        }
      });
    });
  }

  function init(root) {
    initCopyLinkButtons(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
